import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  deleteEmpresa,
  getEmpresaById,
  getEmpresas,
} from "../../api/empresaApi";
import { Empresa, Ferramenta } from "../../types/empresas";
import Tabela from "../../components/Tabela";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Empresas: React.FC = () => {
  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [empresaSelecionada, setEmpresaSelecionada] = useState<Empresa | null>(
    null
  );
  const [modalAberta, setModalAberta] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const empresasData = await getEmpresas(token);
        setEmpresas(empresasData);
      } catch (error) {
        toast.error("Erro ao buscar empresas!");
        console.error("Erro ao buscar empresas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEmpresas();
  }, []);

  const handleAddEmpresa = () => {
    navigate("/adicionarEmpresa");
  };

  const handleEditEmpresa = (id: string) => {
    navigate(`/editarEmpresa/${id}`);
  };

  const handleDeleteEmpresa = async (id: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      await deleteEmpresa(token, id);
      setEmpresas(empresas.filter((empresa) => empresa.id !== Number(id)));
      toast.success("Empresa excluída com sucesso!");
    } catch (error) {
      toast.error("Erro ao excluir Empresa!");
      console.error("Erro ao excluir Empresa:", error);
    }
  };

  const handleViewEmpresa = async (id: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      const empresaData = await getEmpresaById(token, id);
      setEmpresaSelecionada(empresaData);
      setModalAberta(true);
    } catch (error) {
      toast.error("Erro ao carregar detalhes da empresa!");
      console.error("Erro ao carregar detalhes da empresa:", error);
      throw error;
    }
  };

  const handleFecharModal = () => {
    setModalAberta(false);
  };

  const colunas = [
    { id: "id", label: "ID" },
    { id: "cnpj_empresa", label: "CNPJ" },
    { id: "nome_empresa", label: "Nome" },
    {
      id: "logo_empresa",
      label: "Logo",
      render: (value: string) => (
        <img src={value} alt="logo" style={{ width: 50, height: 50 }} />
      ),
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Tabela
        titulo="Empresas"
        colunas={colunas}
        dados={empresas}
        onAdd={handleAddEmpresa}
        onEdit={handleEditEmpresa}
        onView={handleViewEmpresa}
        onDelete={handleDeleteEmpresa}
        showVisibilityIcon={true}
        loading={loading}
      />
      <Modal open={modalAberta} onClose={handleFecharModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            minWidth: "50%",
          }}
        >
          {empresaSelecionada ? (
            <>
              <Typography variant="h6">Ferramentas Cadastradas</Typography>
              {empresaSelecionada.ferramentas.length > 0 ? (
                <TableContainer component={Box} sx={{ maxHeight: 400 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Nome da Ferramenta</TableCell>
                        <TableCell>Nome Token Ferramenta</TableCell>

                        <TableCell>Ativo</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {empresaSelecionada.ferramentas.map(
                        (ferramenta: Ferramenta) => (
                          <TableRow key={ferramenta.id}>
                            <TableCell>{ferramenta.id}</TableCell>
                            <TableCell>{ferramenta.nome_ferramenta}</TableCell>
                            <TableCell>
                              {ferramenta.nome_token_ferramenta}
                            </TableCell>

                            <TableCell>
                              {ferramenta.pivot.ativo_empresa_ferramenta}
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography variant="body1" mt={2}>
                  Nenhuma ferramenta encontrada.
                </Typography>
              )}
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={handleFecharModal}
                >
                  Fechar
                </Button>
              </Box>
            </>
          ) : (
            <Typography variant="body1">
              Nenhuma informação disponível.
            </Typography>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default Empresas;
